import { call, put } from 'redux-saga/effects';

import { dependentFormActions } from '../progress.actions';
import { redirectToPersonalInfo } from './redirect-saga';

export function* setRole(data) {
  yield put(dependentFormActions.setRole(data.role));
  yield call(redirectToPersonalInfo);
}



// WEBPACK FOOTER //
// ./src/redux/dependentForm/sagas/set-role-saga.js